import { type CustomBookedExtraDto, VehicleExtraType } from '@carvia/ros-client-types';
import type { Booking } from '@/entities/bookings/booking.entity';
import type { Pricing } from '@/entities/pricing/pricing.entity';
import { getAllCustomBookedExtras } from '@/utils/pricing.utils';

export function isTransferStyleCustomBookedExtra(
  extra: Pick<CustomBookedExtraDto, 'customVehicleExtraType'>,
): boolean {
  return (
    extra.customVehicleExtraType === VehicleExtraType.TRANSFER_PICKUP ||
    extra.customVehicleExtraType === VehicleExtraType.TRANSFER_RETURN
  );
}

export const getTotalTransferPriceFromPricing = (priceCalculation: Pricing) => {
  const extras = getAllCustomBookedExtras(priceCalculation);
  const pickup = extras.find(
    (extra) => extra.customVehicleExtraType === VehicleExtraType.TRANSFER_PICKUP,
  )?.price;
  const returnPrice = extras.find(
    (extra) => extra.customVehicleExtraType === VehicleExtraType.TRANSFER_RETURN,
  )?.price;

  if (pickup == null && returnPrice == null) {
    return null;
  }

  return (pickup ?? 0) + (returnPrice ?? 0);
};

export const getTotalTransferPrice = (booking: Booking) => {
  if (!booking.priceCalculation) {
    return null;
  }
  return getTotalTransferPriceFromPricing(booking.priceCalculation);
};
